import { freeSet } from '@coreui/icons';
import * as projectTypes from "../constants/projectTypes"; 

export default [
	{
		_tag: "CSidebarNavItem",
		name: "Dashboard",
		to: "/",
		icon: { content: freeSet.cilSpeedometer },
		roles: [],
	},{
		_tag: "CSidebarNavDropdown",
		name: "Projects",
		to: "/projects/0",
		icon: { content: freeSet.cilStar },
		roles: ["admin"],
		_children: [
			{
				_tag: 'CSidebarNavItem',
				name: "Testing Reports",	
				to: `/projects/${projectTypes.TESTING_REPORTS}`,
				roles: ["admin"]			
			},
			{
				_tag: 'CSidebarNavItem',
				name: "Consultancy",
				to: `/projects/${projectTypes.CONSULTANCY}`,
				roles: ["admin"]
			},
			{
				_tag: 'CSidebarNavItem',
				name: "Project Management",
				to: `/projects/${projectTypes.PROJECT_MANAGEMENT}`,
				roles: ["admin"]
			},
			{
				_tag: 'CSidebarNavItem',
				name: "M&J Requests",
				to: `/projects/${projectTypes.MJ_REQUESTS}`,
				roles: ["admin"]
			}
		]
	},
{
		_tag: "CSidebarNavDropdown",
		name: "Organisations",
		to: "/organisations",
		icon: { content: freeSet.cilGlobeAlt },
		roles: ["admin"],
		_children: [
			{
				_tag: 'CSidebarNavItem',
				name: "List",
				to: "/organisations",
				roles: ["admin"]
			},
			{
				_tag: 'CSidebarNavItem',
				name: "Contacts",
				to: "/contacts",
				roles: ["admin"]
			}
		]
	},
	{
		_tag: "CSidebarNavItem",
		name: "Users",
		to: "/users",
		icon: { content: freeSet.cilUser },
		roles: ["admin"],
	},		
	{
		_tag: "CSidebarNavItem",
		name: "Milestone templates",
		to: "/milestoneTemplates",
		icon: { content: freeSet.cilList },
		roles: ["admin"],
	},
	{
		_tag: "CSidebarNavDropdown",
		name: "Reports",
		to: "/engineerReports",
		icon: { content: freeSet.cilGraph },
		roles: ["admin", "engineer"],
		_children: [
			{
				_tag: 'CSidebarNavItem',
				name: "Engineer reports",
				to: "/engineerReports",
				roles: ["admin", "engineer"]
			}
		]
	},
	{
		_tag: "CSidebarNavItem",
		name: "Settings",
		to: "/settings",
		icon: { content: freeSet.cilSettings },
		roles: ["admin"],
	}
];